import React from 'react';
import PropTypes from 'prop-types';
import ThemeToggle from './ThemeToggle';
import Footer from '../common/Footer';
import LanguageSelector from '../common/LanguageSelector';

export default function AuthLayout({ tagline, features, children }) {
  return (
    <div className="auth-page auth-layout">
      <div className="auth-top-bar">
        <LanguageSelector />
        <ThemeToggle />
      </div>
      <div className="auth-layout-inner">
        {/* Left Panel - Branding */}
        <div className="auth-branding">
          <div className="branding-content">
            <div className="branding-logo">
              <div className="branding-logo-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <span className="branding-logo-text">
                Pilot<span>League</span>
              </span>
            </div>

            {tagline && (
              <p className="branding-tagline">{tagline}</p>
            )}

            {features && features.length > 0 && (
              <div className="branding-features">
                {features.map((feature, index) => (
                  <div key={index} className="branding-feature">
                    <div className="branding-feature-icon">{feature.icon}</div>
                    <div className="branding-feature-text">
                      <strong>{feature.title}</strong>
                      {feature.description}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Right Panel - Form */}
        <div className="auth-form-panel">
          <div className="auth-form-container">
            {children}
          </div>
          <Footer variant="auth" />
        </div>
      </div>
    </div>
  );
}

AuthLayout.propTypes = {
  tagline: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
  children: PropTypes.node.isRequired,
};
